import Vue from 'vue';
import Antd from 'ant-design-vue';
import '../style/theme.less';
Vue.use(Antd);
